import { render, staticRenderFns } from "./SoftUpgrade.vue?vue&type=template&id=24a11dd2&scoped=true"
import script from "./SoftUpgrade.vue?vue&type=script&lang=js"
export * from "./SoftUpgrade.vue?vue&type=script&lang=js"
import style0 from "./SoftUpgrade.vue?vue&type=style&index=0&id=24a11dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a11dd2",
  null
  
)

export default component.exports